import { AccessKeysView, ApiIntergrationView, GeneralView, WebsiteIntergrationView } from './tabs';
import { Flex, Stack, Tab, TabList, TabPanel, TabPanels, Tabs, Text } from '@chakra-ui/react';

import React from 'react';
import { ToastContainer } from 'react-toastify';

export const DeveloperHub = () => {

    return (
        <>
            <Flex justifyContent={'center'}>
                <Stack>
                    <Stack bg={'#bbdefb'} p={6} borderRadius={6} maxW={'5xl'}>
                        <Text fontSize={'2xl'} fontWeight={'medium'}>API Integration - Coming Soon. 1st September 😉</Text>
                        <Text>We want you to take advantage of trucklivery business management system and intergrate it with your existing system. We&apos;ll give you all the endpoints to consume.</Text>
                    </Stack>

                    <Stack maxW={'5xl'}>
                        <Tabs colorScheme={'yellow'} mt={6}>
                            <TabList mb={4}>
                                <Tab>Website</Tab>
                                <Tab>Access keys</Tab>
                                <Tab>General</Tab>
                                <Tab>API Integration</Tab>
                            </TabList>

                            <TabPanels>
                                <TabPanel>
                                    <WebsiteIntergrationView />
                                </TabPanel>
                                <TabPanel>
                                    <AccessKeysView />
                                </TabPanel>
                                <TabPanel>
                                    <GeneralView />
                                </TabPanel>
                                <TabPanel>
                                    <ApiIntergrationView />
                                </TabPanel>
                            </TabPanels>
                        </Tabs>
                    </Stack>
                </Stack>
            </Flex>
            <ToastContainer />
        </>
    );
};